var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 123,
    height: 60,
    viewBox: "0 0 123 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.78645 40.1501C2.50105 39.4199 3.41011 39.0547 4.51384 39.0547C5.99069 39.0547 7.07031 39.5443 7.75326 40.5234C8.13043 41.0733 8.33281 41.625 8.3606 42.1787H6.50677C6.3887 41.7535 6.23725 41.4323 6.05262 41.2155C5.72233 40.8304 5.23307 40.6376 4.58445 40.6376C3.92388 40.6376 3.40297 40.9097 3.02175 41.4533C2.64034 41.9972 2.44973 42.7666 2.44973 43.7617C2.44973 44.757 2.65095 45.5023 3.0532 45.9979C3.45564 46.4935 3.9669 46.7412 4.58715 46.7412C5.22285 46.7412 5.70786 46.5286 6.04143 46.103C6.22587 45.8744 6.37905 45.5314 6.50079 45.0738H8.34246C8.18368 46.0409 7.77777 46.8275 7.12471 47.4335C6.47166 48.0394 5.63513 48.3423 4.61494 48.3423C3.35243 48.3423 2.36002 47.933 1.63751 47.1144C0.915 46.2919 0.55365 45.1641 0.55365 43.7316C0.55365 42.1826 0.964582 40.989 1.78645 40.1501Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.1726 45.9583C21.604 45.4165 21.8197 44.6462 21.8197 43.647C21.8197 42.6517 21.604 41.8825 21.1726 41.3386C20.7412 40.7948 20.1584 40.523 19.4241 40.523C18.6897 40.523 18.1038 40.7938 17.6664 41.3356C17.229 41.8775 17.0104 42.6478 17.0104 43.647C17.0104 44.6462 17.229 45.4165 17.6664 45.9583C18.1038 46.5002 18.6897 46.7709 19.4241 46.7709C20.1584 46.7709 20.7412 46.5002 21.1726 45.9583ZM22.3313 47.3066C21.6611 47.9967 20.6921 48.3419 19.4241 48.3419C18.156 48.3419 17.187 47.9967 16.5167 47.3066C15.6179 46.4601 15.1686 45.24 15.1686 43.647C15.1686 42.0218 15.6179 40.8019 16.5167 39.9874C17.187 39.2973 18.156 38.9521 19.4241 38.9521C20.6921 38.9521 21.6611 39.2973 22.3313 39.9874C23.2261 40.8019 23.6735 42.0218 23.6735 43.647C23.6735 45.24 23.2261 46.4601 22.3313 47.3066Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.7161 39.2231H32.6597L36.1815 45.4095V39.2231H37.909V48.0954H36.0555L32.4438 41.8003V48.0954H30.7161V39.2231Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.2767 39.2231H47.2202L50.7421 45.4095V39.2231H52.4695V48.0954H50.6161L47.0043 41.8003V48.0954H45.2767V39.2231Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.4282 40.7938H61.7333V42.678H66.0431V44.2187H61.7333V46.5H66.6449V48.0951H59.9214V39.2227H66.4282V40.7938Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.5951 40.1501C75.3097 39.4199 76.2188 39.0547 77.3225 39.0547C78.7992 39.0547 79.8792 39.5443 80.5619 40.5234C80.9391 41.0733 81.1415 41.625 81.1693 42.1787H79.3154C79.1974 41.7535 79.0459 41.4323 78.8613 41.2155C78.531 40.8304 78.0415 40.6376 77.3931 40.6376C76.7325 40.6376 76.2116 40.9097 75.8302 41.4533C75.4492 41.9972 75.2584 42.7666 75.2584 43.7617C75.2584 44.757 75.4596 45.5023 75.8619 45.9979C76.2643 46.4935 76.7756 46.7412 77.3958 46.7412C78.0315 46.7412 78.5163 46.5286 78.8501 46.103C79.0345 45.8744 79.1877 45.5314 79.3094 45.0738H81.1511C80.9923 46.0409 80.5864 46.8275 79.9336 47.4335C79.2803 48.0394 78.4438 48.3423 77.4236 48.3423C76.1611 48.3423 75.1687 47.933 74.4462 47.1144C73.7237 46.2919 73.3623 45.1641 73.3623 43.7316C73.3623 42.1826 73.7732 40.989 74.5951 40.1501Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.7548 39.2231V40.7943H92.1003V48.0954H90.2343V40.7943H87.5679V39.2231H94.7548Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5734 20.184L16.3233 8.05647L22.1119 20.184H10.5734ZM28.9808 34.5755H32.4537L16.7532 0.834473H15.8981L6.10352e-05 34.5755H3.74996L9.01299 23.4753H23.6827L28.9808 34.5755Z",
    fill: "#1034A6"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.1417 32.0564C44.7048 32.0564 40.2972 27.5479 40.2972 21.9864C40.2972 16.425 44.7048 11.9165 50.1417 11.9165C55.5787 11.9165 59.9861 16.425 59.9861 21.9864C59.9861 27.5479 55.5787 32.0564 50.1417 32.0564ZM50.5999 8.99402C46.4805 8.99402 42.8221 11.0278 40.5093 14.1758V0H37.3202V34.5758H40.5093V29.9917C42.8221 33.1395 46.4805 35.1735 50.5999 35.1735C57.5942 35.1735 63.2641 29.313 63.2641 22.0839C63.2641 14.8543 57.5942 8.99402 50.5999 8.99402Z",
    fill: "#1034A6"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.0936 32.0564C76.6566 32.0564 72.2492 27.5479 72.2492 21.9864C72.2492 16.425 76.6566 11.9165 82.0936 11.9165C87.5307 11.9165 91.9381 16.425 91.9381 21.9864C91.9381 27.5479 87.5307 32.0564 82.0936 32.0564ZM82.5517 8.99402C78.4323 8.99402 74.774 11.0278 72.461 14.1758V0H69.272V34.5758H72.461V29.9917C74.774 33.1395 78.4323 35.1735 82.5517 35.1735C89.546 35.1735 95.2163 29.313 95.2163 22.0839C95.2163 14.8543 89.546 8.99402 82.5517 8.99402Z",
    fill: "#1034A6"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_12047_74054",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 41,
    y: 9,
    width: 82,
    height: 51
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6216 9.58447H122.101V59.9149H41.6216V9.58447Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_12047_74054)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.054 32.5649L122.101 9.58447H118.669L110.34 28.731L101.779 9.58447H98.3467L108.517 32.9214C99.308 50.8614 82.7638 56.8583 69.8874 56.8583C59.6854 56.8583 51.3512 52.9863 46.9496 50.0679L41.6216 50.0719C49.4324 56.2361 59.1258 59.915 69.8874 59.915C86.7601 59.915 103.891 50.527 111.985 32.7146L111.989 32.7138L112.054 32.5649Z",
    fill: "#1034A6"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.baef1c9926bd533f62a9b24af3ec9b1b.svg";
export { ForwardRef as ReactComponent };